<template>
    <div class="mobile-auto-complete-box">
        <div class="mobile-input-wrapper">
            <div
                id="mobile-input-icon-wrapper"
                class="mobileInputIconWrapper"
                @click="onIconClick()"
            >
                <i class="fa fa-search mobileInputIcon"></i>
            </div>
            <input
                ref="input"
                id="auto-complete-input"
                class="mobileAutoCompleteInput"
                :value="value"
                @input="handleInputChange($event)"
                :placeholder="placeholder"
                @blur="handleBlur"
                @focus="handleFocus"
                @keydown.exact.enter="handleReturn"
                @keypress="queryChange"
                @keydown.backspace="queryChange"
                @keydown.exact.up="sugUpdate(-1, $event)"
                @keydown.exact.down="sugUpdate(1, $event)"
            />
        </div>
        <div
            class="mobile-serp-suggestions"
            v-show="hasResults && hasFocus && test()"
        >
            <div
                class="mobile-serp-suggestion"
                :class="{ active: idx == realSelected }"
                @click="handleClick(s.resultEntity, $event)"
                v-for="(s, idx) in items"
                :key="idx"
            >
                <div v-if="query" class="mobile-sug-info">
                    <h4 class="mobile-sug-title" v-html="s.resultEntity"></h4>
                </div>
                <div v-else class="mobile-sug-info">
                    <h4 class="mobile-sug-title" v-html="s.name"></h4>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import debounce from "lodash.debounce";
import trim from "lodash.trim";
import fetchJsonp from "fetch-jsonp";

// autocomplete.js stuff
import memoize from "lodash.memoize";
import queryString from "query-string";
import { RECIPES_FILTER_IMAGE_URLS } from "@/pages/search/views/recipes/Helper";

export default {
    props: ["value", "placeholder", "group", "dev"],
    data() {
        return {
            results: false,
            selected: false,
            errors: false,
            hasFocus: false,
            issued: false,
            query: "",
            prevValue: null,
            api_url: "/core/v2",
            suggestionProvider: null,
            clearCache: null,
        };
    },
    mounted() {
        this.suggestionProvider = this.suggestionProviderFunction();
        this.clearCache = this.clearCacheFunction();
        this.focus();
    },
    updated() {
        if (!this.emptyQuery) {
            this.focus();
            this.handleFocus();
        }
    },
    watch: {
        group() {
            // Immediately clear the cache whenever the vertical changes
            this.results = null;
            this.prevValue = null; // resets no sug for same
            this.suggestionProvider.cache.clear();

            // Automatically remove results when group changes

            // If invalid group number, default to -1 / yahoo web suggest
            if (isNaN(this.group)) this.group = -1;
        },
        value() {
            this.prevValue = null;
        },
    },
    methods: {
        test() {
            if (!this.emptyQuery) return this.prevValue != this.value;
            return true;
        },
        suggestionProviderFunction() {
            return memoize(async term => {
                this.clearCache(); // Make sure the cache doesnt get too big (clears in 1 minute)
                this.prevValue = null; // resets no sug for same

                if (this.group == -1) {
                    const res = await fetchJsonp(
                        `https://us.search.yahoo.com/sugg/gossip/gossip-us-partner?output=jsonp&appid=tig&command=${term}`
                    );

                    if (!res.ok) {
                        return await res.json().catch(e => ({
                            error: "Bad Response",
                            query: term,
                            results: [],
                        }));
                    }
                    const data = await res.json();

                    // Mimic our indexer results
                    const records = data.gossip.results.map(el => ({
                        resultEntity: el.key,
                    }));

                    return {
                        records,
                    };
                }
                if (this.group >= 0) {
                    // Our indexer verticals
                    const qs = {
                        q: term,
                        perPage: 10,
                        pageNo: 0,
                        field: "resultEntity",
                        // filters: { resultImage: { not: FILTER_IMAGE_URLS } },
                    };
                    if (this.group) qs.group = this.group;

                    //  *** START Put specific vertical stuff here *** //

                    // Recipes Vertical (group 9)
                    if (this.qroup == 9)
                        qs.filters = {
                            resultImage: { not: RECIPES_FILTER_IMAGE_URLS },
                        };

                    //  *** END Put specific vertical stuff here *** //

                    const res = await fetch(`${this.api_url}/complete`, {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(qs),
                    });
                    if (!res.ok) {
                        return await res.json().catch(e => ({
                            error: "Bad Response",
                            query: term,
                            results: [],
                        }));
                    }

                    const data = await res.json();

                    return {
                        ...data.main,
                    };
                }
            });
        },
        onIconClick() {
            this.$emit("iconClick");
        },
        clearCacheFunction() {
            const ONE_MINUTE_MS = 60 * 1000;
            return debounce(
                () => this.suggestionProvider.cache.clear(),
                10 * ONE_MINUTE_MS
            );
        },
        handleInputChange(e) {
            this.$emit("input", e.target.value);
        },
        focus() {
            this.$refs.input.focus();
        },
        blur() {
            this.$refs.input.blur();
        },
        handleBlur() {
            if (this.dev) {
                this.haveFocus = true;
            } else {
                window.setTimeout(() => {
                    this.hasFocus = false;
                    this.selected = -1;
                    this.prevValue = this.value;
                }, 500);
                this.$emit("blur");
            }
        },
        handleFocus() {
            this.$nextTick(() => {
                this.hasFocus = true;
            });
            this.$emit("focus");
        },
        handleReturn() {
            // If something is selected we will pick it.
            if (!this.items || this.items == null) this.$emit("return");
            if (this.selected !== false && this.items[this.realSelected]) {
                const elt = this.items[this.realSelected].resultEntity;
                this.$emit("input", elt);
                this.$emit("selected");
            } else {
                this.$emit("return");
            }
        },
        handleClick(item, e) {
            this.$emit("input", item);
            this.$emit("selected");
        },
        sugUpdate(count, e) {
            e.preventDefault();
            if (count == false) {
                this.selected = false;
                return;
            }
            if (this.selected === false) {
                this.selected = count < 0 ? -1 : 0;
                if (typeof this.items[this.selected] !== "undefined")
                    this.$emit("input", this.items[this.selected].resultEntity);
                return;
            }
            this.selected += count;
            if (typeof this.items[this.selected] !== "undefined")
                this.$emit("input", this.items[this.selected].resultEntity);
        },
        async queryChange(e) {
            if (e.keyCode != 13) {
                if (this.issued) {
                    this.issued = false;
                    this.request(false);
                    return;
                }
                if (this.results && this.query && this.value) {
                    if (this.query.length > this.value.length) {
                        this.clear();
                    }
                }
                await this.request();
            } else {
                this.$refs.input.blur();
            }
        },
        clear() {
            this.results = false;
            this.selected = false;
        },
        request: debounce(async function(cancel) {
            const term = trim(this.value);
            const lastResult = this.results;
            if (term === "" || cancel) {
                this.clear();
                return;
            }
            try {
                const res = await this.suggestionProvider(term);
                if (this.value.indexOf(term) == -1) {
                    if (lastResult == this.results) {
                        this.clear();
                    }
                    return;
                }

                this.results = res.records;
            } catch (e) {
                this.results = [];
            }
        }, 300),
    },
    computed: {
        hasResults() {
            if (this.emptyQuery)
                return this.defaultHistory && this.defaultHistory.length > 0;
            return this.results && this.items.length > 0;
        },
        realSelected() {
            if (this.selected === false) return -1;
            if (this.items === false) return -1;
            if (!this.items) return -1;
            return this.selected % this.items.length;
        },
        items() {
            if (this.emptyQuery) return this.defaultHistory;
            return this.results && this.results;
        },
        emptyQuery() {
            if (!this.value || this.value.trim() == "") return true;
            return false;
        },
    },
};
</script>

<style scoped src="./mobileautocompleteinput.css"></style>
